import { combineReducers, createStore } from 'redux';

import * as ducks from './ducks';
import { removeLegacySelectedEvent } from '../helpers/selectedEvent';

const reducers = combineReducers(ducks);

const store = createStore(
  reducers,
  window &&
    (window as any).__REDUX_DEVTOOLS_EXTENSION__ &&
    (window as any).__REDUX_DEVTOOLS_EXTENSION__(),
);

// The selected event is per page now (persisted per page by
// useGlobalEvent().setEventId); drop the old single global key.
removeLegacySelectedEvent();

export default store;
